import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Fragment, useState } from 'react'

import { PipelineInput } from '@ui/__generated__/graphql'
import { Button } from '@ui/components/core'
import { useSavePipeline } from '@ui/lib/hooks/useSavePipeline'

export function SaveModal({
  open,
  setOpen,
  pipeline,
}: {
  open: boolean
  setOpen: (value: boolean) => void
  pipeline: PipelineInput
}) {
  const { updateWorkflow } = useSavePipeline()

  const [name, setName] = useState('')

  const onClick = async (enabled: boolean = false) => {
    await updateWorkflow({
      pipeline,
      isNew: true,
      name,
      enabled,
    })
    setOpen(false)
  }

  return (
    <Transition.Root show={open} as={'div'}>
      <Dialog as="div" className="relative z-40" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-gray-500/75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <Dialog.Panel
                className="relative overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
                data-testid="save-modal">
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500"
                    onClick={() => setOpen(false)}>
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="sm:flex sm:items-start">
                  <div className="m-4 mt-3 w-full text-center sm:mt-0 sm:text-left">
                    <Dialog.Title as="h3" className="text-xl font-semibold leading-6 text-gray-900">
                      Save pipeline
                    </Dialog.Title>
                    <Dialog.Description as={'div'}>
                      <div className="mt-4">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                          Name
                        </label>
                        <div className="mt-1">
                          <input
                            type="text"
                            name="name"
                            id="name"
                            className="block w-full rounded-md border-gray-400 shadow-sm focus:border-secondary-200  focus:outline-none sm:text-sm "
                            placeholder={name || 'Pipeline name'}
                            onChange={(event) => setName(event.target.value)}
                            value={name}
                            autoComplete="none"
                          />
                        </div>
                      </div>

                      <div className="w-full">
                        {/* <Notification
                          show={notification?.show || false}
                          type={NotificationTypeEnum.ERROR}
                          title={notification?.title || ''}
                          message={notification?.message}
                          richMessage={notification?.richMessage}
                          messageList={notification?.messageList}
                        /> */}
                      </div>
                    </Dialog.Description>
                  </div>
                </div>
                <div className="flex w-full flex-row justify-end">
                  <Button onClick={async () => onClick(true)}>Save and enable</Button>
                  <Button variant={'secondary'} onClick={async () => onClick(false)}>
                    Save
                  </Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
